import React from 'react';
import smilingGirlJpg from 'assets/images/smiling-girl.jpg';
import smilingGirlWebp from 'assets/images/smiling-girl.jpg?as=webp';
import smilingGirlJpgPlaceholder from 'assets/images/smiling-girl-placeholder.jpg';
import smilingGirlJpgPlaceholderWebp from 'assets/images/smiling-girl-placeholder.jpg?as=webp';
import smilingGirlPng from 'assets/images/smiling-girl-2.png';
import smilingGirlPngWebp from 'assets/images/smiling-girl-2.png?as=webp';
import LazyLoad from 'react-lazyload';
import { checkWebPSupport } from 'supports-webp-sync';
import loadable from '@loadable/component';
import { useProgressiveImage } from '../../hooks';

const FadeIn = loadable(() => import('../common/FadeIn'));

const OverlayBlock = () => {
  const isWebPSupport = checkWebPSupport();
  const placeholder = isWebPSupport ? smilingGirlJpgPlaceholderWebp : smilingGirlJpgPlaceholder;
  const loaded = useProgressiveImage(isWebPSupport ? smilingGirlWebp : smilingGirlJpg);

  return (
    <section className='overlay-block'>
      <div className='overlay-block__inner' style={{ backgroundImage: `url(${loaded || placeholder})` }}>
        <div className='container'>
          <div className='overlay-block__content'>
            <h2 className='overlay-block__title'>Named after one of our own.</h2>
            <div className='overlay-block__description'>
              <p>
                As you may have guessed, we named the company Mila after one of our own kids—so that we’d be constantly
                reminded of our commitment not just to our own families, but to families around the world.
              </p>
            </div>
          </div>
        </div>
        <figure className='overlay-block__image'>
          <LazyLoad>
            <FadeIn>
              <picture>
                <source srcSet={smilingGirlPngWebp} type='image/webp' />
                <source srcSet={smilingGirlPng} type='image/png' />
                <img src={smilingGirlPng} alt='smiling-girl' />
              </picture>
            </FadeIn>
          </LazyLoad>
        </figure>
      </div>
    </section>
  );
};

export default OverlayBlock;
